require('./bootstrap');

// Import modules...
import {createApp, h} from 'vue';
import {App as InertiaApp, plugin as InertiaPlugin} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import {Translate} from "./helpers";
import {__, trans, setLocale, getLocale, transChoice, MaticeLocalizationConfig, locales} from "matice"
import VueTippy from "vue-tippy";

let VueScrollTo = require('vue-scrollto');
import Layout from '@/Layouts/AppLayout'
import VueSmoothScroll from 'vue3-smooth-scroll'

const el = document.getElementById('app');

const app = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`)
                .default
            // .then(({ default: page }) => {
            //     if (page.layout === undefined) {
            //       page.layout = Layout
            //     }
            //     return page
            // }),
        }),
    })
    .mixin({
        methods: {
            route,
            $trans: trans,
            $__: __,
            $transChoice: transChoice,
            $setLocale(locale) {
                setLocale(locale);
                this.$forceUpdate() // Refresh the vue instance(The whole app in case of SPA) after the locale changes.
            },
            // The current locale
            $locale() {
                return getLocale()
            },
            // A listing of the available locales
            $locales() {
                return locales()
            }
        }
    })
    .mixin(Translate)
    .use(InertiaPlugin)
    .use(VueSmoothScroll)
    .directive('scroll-to', VueScrollTo)
    .use(VueTippy, {
        directive: 'tippy',
    })
    .mount(el);


InertiaProgress.init({color: '#4B5563'});
